<template>
  <label class="custom-checkbox">
    <input
        type="checkbox"
        :checked="value"
        @change="$emit('input', $event.target.checked)"
    />
    <span
        class="custom-checkbox__icon"
        :class="{ checked: value }"
    >
      <svg
          v-if="value"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
      >
        <path
            fill="white"
            d="M9.29 16.29L4.7 11.7a1 1 0 1 1 1.4-1.42l3.6 3.6 8.6-8.6a1 1 0 0 1 1.4 1.42l-10 10a1 1 0 0 1-1.41 0Z"
        />
      </svg>
    </span>
    <span class="custom-checkbox__label">
      Даю согласие на обработку персональных данных
    </span>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__label {
    user-select: none;
    font-family: Open Sans, sans-serif;
    font-weight: 400;
    font-size: 11px;
    line-height: 130%;
    letter-spacing: 0;
    vertical-align: middle;
    color: #637281;
  }

  input[type="checkbox"] {
    display: none;
  }

  &__icon {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    border-radius: 4px;
    background-color: white;
    border: 1px solid var(--dark-grey);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    transition: background-color 0.2s ease;

    &:not(.checked):hover {
      background-color: var(--bg);
    }
  }

  &__icon.checked {
    background-color: #6e7881;
  }
}
</style>
